/**
 * Created by ray on 12/27/2016.
 */
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot,  RouterStateSnapshot } from '@angular/router';
import {AuthService} from './../service/auth.service';
import {Observable} from 'rxjs';
import {MsgService} from "../service/message.service";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router:Router, private authService:AuthService, private msgService: MsgService) {
  }

  canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot):Observable<boolean> {
    const url = state.url;
    const observable:Observable<boolean> = Observable.create(observer => {
      this.authService.checkLogin(value => {
        observer.next(value);
        if (!value) {
          state.url = '/login';
          this.msgService.showError('Unauthorized', 'Please Login First.');
        }
      });
    });

    return observable;
  }
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/guards/auth.guard.ts